// extracted by mini-css-extract-plugin
module.exports = {"qrcode-container":"index_qrcode-container__oZDoQ","qrcodeContainer":"index_qrcode-container__oZDoQ","logo":"index_logo__z9Wjq"};